import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from '@apollo/client/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  Query,
  QueryLtlQuoteRequestsWhereWhereConditions,
  QueryShipmentsWhereWhereConditions,
} from '@graphql-types';
import { QueriesBaseService } from '@services/queries/queries-base.service';
import { globalSearchQuery } from '@services/queries/queries/global-search.queries';

export interface GlobalSearchRequest {
  page?: number;
  size?: number;
  whereShipments?: QueryShipmentsWhereWhereConditions;
  whereQuotes?: QueryLtlQuoteRequestsWhereWhereConditions;
  canQueryShipment: boolean;
  canQueryQuote: boolean;
}

export type GlobalSearchResponse = Pick<
  Query,
  'shipments' | 'ltlQuoteRequests'
>;

@Injectable({
  providedIn: 'root',
})
export class SearchQueriesService extends QueriesBaseService {
  private _apollo = inject(Apollo);

  getGlobalSearchResults(
    request: GlobalSearchRequest
  ): Observable<GlobalSearchResponse> {
    const {
      page = 1,
      size = 20,
      whereShipments,
      whereQuotes,
      canQueryShipment,
      canQueryQuote,
    } = request;

    return this._apollo
      .query<Query>({
        query: globalSearchQuery,
        variables: {
          page,
          size,
          whereShipments,
          whereQuotes,
          canQueryShipment,
          canQueryQuote,
        },
        fetchPolicy: 'no-cache',
      })
      .pipe(map((res: ApolloQueryResult<Query>) => res?.data));
  }
}
